import React from "react";
import PropTypes from "prop-types";
import SVG from "components/base/SVG";
import { Link } from 'react-router-dom';

import DropdownToggle from "../../../components/DropdownToggle";
import ToolsIcon from "../../../assets/images/ToolsIcon.svg";

import css from "./style.scss";

const ToolItemWrapper = ({ children, className, link, onClick, key }) => link ? <Link className={className} to={link} key={key}>{children}</Link> : <div className={className} onClick={onClick} key={key}>{children}</div>;


const ToolItemDropdown = ({ items, onToggle }) => {
  return (
    <DropdownToggle
      onToggle={onToggle}
      buttonLabel={
        <div className={css.toolsButton}>
          <img src={ToolsIcon} className={css.toolsIcon} alt={`Tool Icon`} />
          Tools
          <span className={css.buttonLabel}>NEW</span>
          <SVG icon="iconCaretDown" className={css.iconCaretDown} />
        </div>
      }
      renderChildren={({ closeDropdown }) => (
        <div className={css.toolWrapper}>
          {items.filter(each => !each.hidden).map((item) => <ToolItemWrapper

            className={css.toolItem}
            onClick={() => {
              if (item.onClick) item.onClick();
              closeDropdown();
            }}
            link={item.link}
            key={item.name}
          >
            <img src={item.icon} className={css.toolItemIcon} alt={`${item.name} Logo`} />
            <div className={css.toolItemInfoWrapper}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <p className={css.toolItemTitle}>{item.name}</p>
                {item.isNew && <span className={css.newBadge}>NEW</span>}
              </div>
              <p className={css.toolItemDescription}>{item.description}</p>
            </div>
          </ToolItemWrapper>
          )}
        </div>
      )}
    />
  );
};

ToolItemDropdown.propTypes = {
  onToggle: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      hidden: PropTypes.bool,
      link: PropTypes.string,
      isNew: PropTypes.bool,
    }),
  ).isRequired,
};

export default ToolItemDropdown;

